import BaseAPI from './BaseAPI';

// All appointment / photo / staff endpoints exposed by ace-car-spa-server.
class AppointmentsAPI extends BaseAPI {
  constructor() {
    super('');
  }

  getAppointments(date, location = 'all') {
    return this.get(`/appointments?location=${location}&date=${date}`);
  }

  // Daily revenue per location over [start, end] (YYYY-MM-DD) for analytics.
  getAnalytics(start, end) {
    return this.get(`/appointments/analytics?start=${start}&end=${end}`);
  }

  // `paymentMethod` is a paymentMethods.code; `paymentDetails` carries whatever
  // that method needs (reason, invoiceNumber, billedTo, ...).
  updateCheck({ externalId, step, check, comment, paymentMethod, paymentDetails }) {
    return this.put('/appointments', {
      body: { externalId, step, check, comment, paymentMethod, paymentDetails },
    });
  }

  // GET /appointments/ledger?start=&end= → { appointments: [...] }
  // Every booking in the range with how its money was handled.
  getLedger(start, end) {
    return this.get(`/appointments/ledger?start=${start}&end=${end}`);
  }

  // GET /appointments/:externalId/payment — breakdown + reconciliation state for
  // the appointment drawer.
  getPaymentDetail(externalId) {
    return this.get(`/appointments/${encodeURIComponent(externalId)}/payment`);
  }

  updateStaffAssignment({ externalId, staffId, assign }) {
    return this.put('/appointments/assign', {
      body: { externalId, staffId, assign },
    });
  }

  getPhotos({ idBooking, customerName, serviceLabel, date }) {
    const query = `customerName=${encodeURIComponent(customerName)}&serviceLabel=${encodeURIComponent(serviceLabel)}&date=${date}`;
    return this.get(`/photos/${encodeURIComponent(idBooking)}?${query}`);
  }

  uploadPhotos({ files, idBooking, customerName, serviceLabel, phase, date }) {
    const formData = new FormData();
    files.forEach((f) => formData.append('photos', f));
    formData.append('idBooking', idBooking);
    formData.append('customerName', customerName);
    formData.append('serviceLabel', serviceLabel);
    formData.append('phase', phase || '');
    formData.append('date', date);
    return this.post('/photos/upload', { body: formData });
  }
}

export const AppointmentsService = new AppointmentsAPI();
export default AppointmentsAPI;
